/**
 * Product Image Lightbox
 * - Zoom button rendered in Liquid, shown via CSS when slick initializes
 * - Preloads all images for instant slide navigation
 * - Double-click/double-tap to zoom to full viewport
 * - Touch swipe support on mobile
 * - YouTube video playback support
 */
(function () {
  'use strict';

  var lightbox = document.getElementById('ProductLightbox');
  if (!lightbox) return;

  var imageEl = lightbox.querySelector('.product-lightbox__image');
  var videoEl = lightbox.querySelector('.product-lightbox__video');
  var imageWrap = lightbox.querySelector('.product-lightbox__image-wrap');
  var counterEl = lightbox.querySelector('.product-lightbox__counter');
  var closeBtn = lightbox.querySelector('.product-lightbox__close');
  var prevBtn = lightbox.querySelector('.product-lightbox__nav--prev');
  var nextBtn = lightbox.querySelector('.product-lightbox__nav--next');

  var slides = [];
  var preloaded = {};
  var currentIndex = 0;
  var isOpen = false;
  var isZoomed = false;

  /**
   * Extract YouTube video ID from a youtu.be or youtube.com URL.
   * Supports:
   *   https://youtu.be/VIDEO_ID
   *   https://www.youtube.com/watch?v=VIDEO_ID
   *   https://youtube.com/embed/VIDEO_ID
   * Returns null if no valid ID found.
   */
  function extractYouTubeId(url) {
    if (!url) return null;
    var match = url.match(/youtu\.be\/([a-zA-Z0-9_-]+)/) ||
                url.match(/youtube\.com\/watch\?v=([a-zA-Z0-9_-]+)/) ||
                url.match(/youtube\.com\/embed\/([a-zA-Z0-9_-]+)/);
    return match ? match[1] : null;
  }

  // Collect all product slides (images + videos) from slick slider
  function collectSlides() {
    slides = [];
    preloaded = {};
    var desktopSlider = document.querySelector('.desktopsloder .product-slider-for');
    var mobileSlider = document.querySelector('.mobileslider .product-slider-for');
    var slider = desktopSlider || mobileSlider;

    if (!slider) return;

    var slideImgs = slider.querySelectorAll('.slick-slide:not(.slick-cloned) .product-single__photo img, .slick-slide:not(.slick-cloned) > img');
    if (slideImgs.length === 0) {
      slideImgs = slider.querySelectorAll('.product-single__photo img');
    }

    slideImgs.forEach(function (img) {
      var src = img.getAttribute('src') || '';
      var alt = img.getAttribute('alt') || '';
      var videoId = extractYouTubeId(alt);

      if (videoId) {
        // This is a YouTube video slide
        slides.push({
          type: 'video',
          videoId: videoId,
          src: src, // poster image
          alt: alt
        });
      } else {
        // Regular image slide
        var highResSrc = src.replace(/(_\d+x\d+|_\d+x)/, '_1024x1024');
        if (!highResSrc.match(/_1024x1024/)) {
          highResSrc = src;
        }
        slides.push({
          type: 'image',
          src: highResSrc,
          alt: alt
        });
      }
    });
  }

  // Preload all images (skip videos) so navigation is instant
  function preloadAllImages() {
    slides.forEach(function (slideData) {
      if (slideData.type === 'image' && !preloaded[slideData.src]) {
        var img = new Image();
        img.src = slideData.src;
        preloaded[slideData.src] = img;
      }
    });
  }

  function getCurrentSlideIndex() {
    try {
      var desktopSlider = jQuery('.desktopsloder .product-slider-for');
      var mobileSlider = jQuery('.mobileslider .product-slider-for');

      if (window.innerWidth >= 768 && desktopSlider.length && desktopSlider.hasClass('slick-initialized')) {
        return desktopSlider.slick('slickCurrentSlide') || 0;
      } else if (mobileSlider.length && mobileSlider.hasClass('slick-initialized')) {
        return mobileSlider.slick('slickCurrentSlide') || 0;
      }
    } catch (e) {}
    return 0;
  }

  function updateCounter() {
    if (counterEl && slides.length > 0) {
      counterEl.textContent = (currentIndex + 1) + '/' + slides.length;
    }
  }

  function updateNavButtons() {
    if (prevBtn) prevBtn.disabled = currentIndex <= 0;
    if (nextBtn) nextBtn.disabled = currentIndex >= slides.length - 1;
  }

  function unzoom() {
    if (!isZoomed) return;
    isZoomed = false;
    imageEl.classList.remove('is-zoomed');
    imageWrap.classList.remove('is-zoomed-wrap');
  }

  /** Stop any playing video by clearing the iframe src */
  function stopVideo() {
    if (videoEl) {
      videoEl.src = '';
    }
  }

  function showSlide(index) {
    if (index < 0 || index >= slides.length) return;

    // Stop any currently playing video before switching
    stopVideo();
    currentIndex = index;
    unzoom();

    var slide = slides[index];

    if (slide.type === 'video') {
      // Show YouTube iframe, hide image
      imageEl.style.display = 'none';
      videoEl.style.display = 'block';
      videoEl.src = 'https://www.youtube.com/embed/' + slide.videoId + '?autoplay=1&rel=0&modestbranding=1';
      imageWrap.classList.add('is-video-wrap');
    } else {
      // Show image, hide iframe
      videoEl.style.display = 'none';
      imageEl.style.display = '';
      imageEl.src = slide.src;
      imageEl.alt = slide.alt;
      imageWrap.classList.remove('is-video-wrap');
    }

    updateCounter();
    updateNavButtons();
  }

  function openLightbox() {
    collectSlides();
    if (slides.length === 0) return;

    preloadAllImages();

    var idx = getCurrentSlideIndex();
    if (idx >= slides.length) idx = 0;

    document.body.classList.add('lightbox-open');
    isOpen = true;

    showSlide(idx);
    lightbox.classList.add('is-active');
  }

  function closeLightbox() {
    stopVideo();
    lightbox.classList.remove('is-active');
    document.body.classList.remove('lightbox-open');
    unzoom();
    isOpen = false;
  }

  function goNext() {
    if (currentIndex < slides.length - 1) {
      showSlide(currentIndex + 1);
    }
  }

  function goPrev() {
    if (currentIndex > 0) {
      showSlide(currentIndex - 1);
    }
  }

  function toggleZoom() {
    // Don't allow zoom on video slides
    if (slides[currentIndex] && slides[currentIndex].type === 'video') return;

    if (isZoomed) {
      unzoom();
    } else {
      isZoomed = true;
      imageEl.classList.add('is-zoomed');
      imageWrap.classList.add('is-zoomed-wrap');
    }
  }

  // --- Event Listeners ---

  // Magnify icon clicks (delegated)
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.product-gallery__zoom-btn');
    if (btn) {
      e.preventDefault();
      e.stopPropagation();
      openLightbox();
    }
  });

  // Active product image clicks (delegated)
  document.addEventListener('click', function (e) {
    var activeSlide = e.target.closest('.product-single__photo.slick-slide.slick-current.slick-active');
    if (activeSlide) {
      e.preventDefault();
      e.stopPropagation();
      openLightbox();
    }
  });

  if (closeBtn) {
    closeBtn.addEventListener('click', function (e) {
      e.preventDefault();
      closeLightbox();
    });
  }

  lightbox.addEventListener('click', function (e) {
    if (e.target === lightbox || e.target.classList.contains('product-lightbox__image-wrap')) {
      closeLightbox();
    }
  });

  if (prevBtn) prevBtn.addEventListener('click', function (e) { e.stopPropagation(); goPrev(); });
  if (nextBtn) nextBtn.addEventListener('click', function (e) { e.stopPropagation(); goNext(); });

  // Desktop: standard dblclick
  if (imageEl) {
    imageEl.addEventListener('dblclick', function (e) {
      e.preventDefault();
      e.stopPropagation();
      toggleZoom();
    });

    imageEl.addEventListener('click', function (e) {
      e.stopPropagation();
    });
  }

  // Prevent video iframe clicks from closing lightbox
  if (videoEl) {
    videoEl.addEventListener('click', function (e) {
      e.stopPropagation();
    });
  }

  // Mobile: custom double-tap (dblclick doesn't fire reliably on touch devices)
  var lastTapTime = 0;
  var lastTapX = 0;
  var lastTapY = 0;
  var DOUBLE_TAP_DELAY = 300; // ms
  var DOUBLE_TAP_RADIUS = 30; // px — taps must be close together

  if (imageEl) {
    imageEl.addEventListener('touchend', function (e) {
      if (!isOpen) return;

      var now = Date.now();
      var touch = e.changedTouches[0];
      var tapX = touch.clientX;
      var tapY = touch.clientY;

      var timeDiff = now - lastTapTime;
      var distX = Math.abs(tapX - lastTapX);
      var distY = Math.abs(tapY - lastTapY);

      if (timeDiff < DOUBLE_TAP_DELAY && distX < DOUBLE_TAP_RADIUS && distY < DOUBLE_TAP_RADIUS) {
        // Double-tap detected
        e.preventDefault();
        toggleZoom();
        lastTapTime = 0; // reset so triple-tap doesn't re-trigger
      } else {
        lastTapTime = now;
        lastTapX = tapX;
        lastTapY = tapY;
      }
    });
  }

  // Keyboard
  document.addEventListener('keydown', function (e) {
    if (!isOpen) return;
    switch (e.key) {
      case 'Escape':
        closeLightbox();
        break;
      case 'ArrowLeft':
        goPrev();
        break;
      case 'ArrowRight':
        goNext();
        break;
    }
  });

  // Touch swipe for slide navigation
  var touchStartX = 0;
  var touchStartY = 0;
  var isSwiping = false;

  lightbox.addEventListener('touchstart', function (e) {
    if (isZoomed) return;
    touchStartX = e.changedTouches[0].screenX;
    touchStartY = e.changedTouches[0].screenY;
    isSwiping = true;
  }, { passive: true });

  lightbox.addEventListener('touchend', function (e) {
    if (!isSwiping || isZoomed) return;
    isSwiping = false;
    var diffX = touchStartX - e.changedTouches[0].screenX;
    var diffY = Math.abs(touchStartY - e.changedTouches[0].screenY);

    if (Math.abs(diffX) > 50 && diffY < 100) {
      if (diffX > 0) {
        goNext();
      } else {
        goPrev();
      }
    }
  }, { passive: true });

  // Prevent default zoom gesture on lightbox to avoid browser interfering
  lightbox.addEventListener('touchmove', function (e) {
    if (isOpen && !isZoomed) {
      // Allow horizontal swipe but prevent pinch-zoom interference
    }
  }, { passive: true });

})();
